var _circle, _ellipse, _ellipse2, _line, _ellipse3, _ellipse4, _line2, _path, _text, _path2, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOkoyeExportsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "globeGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a5f2a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2d8f45",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrowGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#d4af37",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f4d03f",
      stopOpacity: 1
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 95,
    fill: "url(#globeGradient)",
    stroke: "#0d3d15",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 100,
    rx: 70,
    ry: 25,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    opacity: 0.4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 100,
    rx: 70,
    ry: 50,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    opacity: 0.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 100,
    x2: 170,
    y2: 100,
    stroke: "#ffffff",
    strokeWidth: 2,
    opacity: 0.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 100,
    rx: 25,
    ry: 70,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    opacity: 0.4
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 100,
    rx: 50,
    ry: 70,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    opacity: 0.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 30,
    x2: 100,
    y2: 170,
    stroke: "#ffffff",
    strokeWidth: 2,
    opacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 60 130 L 100 70 L 140 130 L 115 130 L 115 160 L 85 160 L 85 130 Z",
    fill: "url(#arrowGradient)",
    stroke: "#b8860b",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 145,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 28,
    fontWeight: "bold",
    fill: "#ffffff",
    textAnchor: "middle"
  }, "OE")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "textPath",
    d: "M 30 180 Q 100 210 170 180",
    fill: "none"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fill: "#ffffff",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("textPath", {
    href: "#textPath",
    startOffset: "50%",
    textAnchor: "middle"
  }, "OKOYE EXPORTS"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkoyeExportsLogo);
export default __webpack_public_path__ + "static/media/okoye_exports_logo.5ad6f7d0eb5ecf4782c985ba35788bf4.svg";
export { ForwardRef as ReactComponent };